/* *** Fevre River Database *** */
/* (C) 2026 - Joti Software, LLC */

// Parris Collection Decision View //

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Card, Col, Collapse, FloatingLabel, Form, Offcanvas, Row, Spinner, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import produce from 'immer';
import axios from 'axios';

import { ColorBlock } from './ColorBlock';
import { faCheckCircle, faBars } from '@fortawesome/free-solid-svg-icons';

const baseURI = process.env.REACT_APP_API_URI + '/';
const progressListItemsURI = baseURI + 'items/parris-progress-list/';
const progressStatusURI = baseURI + 'items/parris-progress-status/';
const parrisItemURI = baseURI + 'items/parris';
const skipItemURI = parrisItemURI + '/skip/';
const keepItemURI = parrisItemURI + '/keep/';
const giftItemURI = parrisItemURI + '/gift/';

function ThumbImage(props) {
	return <div className="d-inline-block text-center me-3"><img className="table-thumbnail table-thumbnail-sm" src={baseURI+props.item.imageRef} alt="Item" /></div>
}

function DetailImage(props) {
	return (
		(props.item.imageRef)
		?	<img className="detail-pic" src={baseURI+props.item.imageRef} onLoad={props.onLoad} alt="Item" />
		:	''
	);
}

function ParrisDecision(props) {
	const decision = props.item.parrisCollectionInfo.decision;
	const buttonStyles = {
		'KEEP': 'surprise',
		'GIFT': 'success',
		'': 'secondary'
	};
	return (decision !== "")
		?	<Button className="btn-display" variant={buttonStyles[decision]} size="xs">{decision}</Button>
		:	<em className="text-muted">--</em>;
}

function LoadingOverlay(props) {
	return (
		(props.show)
		?	(
				<div className="LoadingOverlay">
					<div className="d-flex align-items-center">
						<Spinner as="span" animation="border" role="status" aria-hidden="true" />
						<span className="ms-3">Loading...</span>
					</div>
				</div>
			)
		: ''
	);
}

function SavingOverlay(props) {
	return (
		(props.show)
		?	(
				<div className="LoadingOverlay">
					<div className="d-flex align-items-center">
						<Spinner as="span" animation="border" role="status" aria-hidden="true" />
						<span className="ms-3">Saving...</span>
					</div>
				</div>
			)
		: ''
	);
}

class ParrisView extends Component {

	constructor(props) {
		super(props);

		this.getProgressList = this.getProgressList.bind(this);
		this.getProgressStatus = this.getProgressStatus.bind(this);
		
		this.handleListShow = this.handleListShow.bind(this);
		this.handleListHide = this.handleListHide.bind(this);
		// this.handleEditButtonClick = this.handleEditButtonClick.bind(this);
		this.handleGiftItemClick = this.handleGiftItemClick.bind(this);
		this.handleKeepItemClick = this.handleKeepItemClick.bind(this);
		this.handleGiftCancelClick = this.handleGiftCancelClick.bind(this);
		this.handleKeepCancelClick = this.handleKeepCancelClick.bind(this);

		this.handleImageLoaded = this.handleImageLoaded.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleGiftItemFormSubmit = this.handleGiftItemFormSubmit.bind(this);
		this.handleKeepItemFormSubmit = this.handleKeepItemFormSubmit.bind(this);
		this.handleSkipItem = this.handleSkipItem.bind(this);
		this.handleKeepItem = this.handleKeepItem.bind(this);
		this.handleGiftItem = this.handleGiftItem.bind(this);

		this.state = {
			progressListItems: [],
			progressListStatus: {
				totalCount: '',
				currentItemNumber: ''
			},
			item: {
				hasImageUpload: false,
				title: '',
				subTitle: '',
				creators: [],
				type: '',
				medium: '',
				location: {
					property: '',
					building: '',
					room: '',
					wall: '',
					case: '',
					shelf: '',
					positionX: '',
					positionY: '',
					notes: ''
				},
				bragLocation: {
					property: '',
					building: '',
					room: '',
					wall: '',
					case: '',
					shelf: '',
					positionX: '',
					positionY: '',
					notes: ''
				},
				otherLocation: {
					property: '',
					building: '',
					room: '',
					wall: '',
					case: '',
					shelf: '',
					positionX: '',
					positionY: '',
					notes: ''
				},
				quantity: '',
				countryOfOrigin: '',
				primaryColors: [],
				dimensions: {
					length: '',
					width: '',
					height: ''
				},
				appraisalInfo: null,		// TODO
				provenanceInfo: null,		// TODO
				miscDocRefs: [],
				notes: [
					{
						text: '',
						createdBy: this.props.currentUser._id
					}
				],
				addMethod: '',
				addedBy: '',
				editHistory: [],
				linkedItems: [],
				artInfo: {
					artCollection: '',
					framed: false
				},
				bookInfo: {
					genre: '',
					style: '',
					subTitle: '',
					collectionSubTitles: [],
					isbn: '',
					publisher: '',
					dateOfPublication: '',
					language: '',
					bookCollection: '',
					setInfo: {
						primeCopyReceived: false,
						primeCopyReceivedDate: '',

						texasAMCopyReceived: false,
						texasAMCopyReceivedDate: '',
						texasAMCopySent: false,
						texasAMCopySentDate: '',

						leslieCopyReceived: false,
						leslieCopyReceivedDate: '',
						leslieCopySent: false,
						leslieCopySentDate: '',

						bragCopyReceived: false,
						bragCopyReceivedDate: '',

						otherCopyReceived: false
					}
				},
				parrisCollectionInfo: {
					decision: '',
					decisionDate: '',
					giftInfo: {
						firstName: '',
						lastName: '',
						additionalDetails: ''
					}
				}
			},
			
			primeLocationCollapsed: false,
			bragLocationCollapsed: true,
			otherLocationCollapsed: true,

			isLoading: true,
			isSaving: false,

			editingActive: {
				title: false,
				creator: false
			},

			progressListShow: false,
			keepDetailsOpen: false,
			giftDetailsOpen: false
		};
	}

	componentDidMount() {
		// Get item
		axios.get(parrisItemURI)
			.then(response => {
				if (response.data) {
					this.setState({ item: response.data });
				}
				else {
					this.props.history.replace('/item-not-found');
				}
			})
			.catch(err => console.log(err));

		// Get progress list
		this.getProgressList();

		// Get progress status
		this.getProgressStatus();
	}

	getProgressList() {
		axios.get(progressListItemsURI)
			.then(response => {
				this.setState({ progressListItems: response.data.slice(0, 24) });
			})
			.catch(err => console.log(err));
	}

	getProgressStatus() {
		axios.get(progressStatusURI)
			.then(response => {
				this.setState({ progressListStatus: response.data });
			})
			.catch(err => console.log(err));
	}

	// clearKeepForm() {
		
	// }
	// clearGiftForm() {

	// }

	// Handle updates on image loaded
	handleImageLoaded() {
		this.setState({ isLoading: false });
	}

	// Handle show/hide progress list
	handleListShow() {
		this.setState({ progressListShow: true });
	}

	handleListHide() {
		this.setState({ progressListShow: false });
	}

	// Handle field editing
	// handleEditButtonClick(e) {
	// 	// get edit button name, and toggle editing functionality
	// 	const name = e.currentTarget.dataset.name;
	// 	this.setState(produce(draftState => { draftState.editingActive[name] = !draftState.editingActive[name] }));
	// }

	// Handle KEEP/GIFT interface opening/closing
	handleGiftItemClick() {
		this.setState({ giftDetailsOpen: !this.state.giftDetailsOpen, keepDetailsOpen: false });
	}

	handleKeepItemClick() {
		this.setState({ keepDetailsOpen: !this.state.keepDetailsOpen, giftDetailsOpen: false  });
	}

	handleGiftCancelClick() {
		// clear form, & close collapse
		this.setState({ giftDetailsOpen: false, keepDetailsOpen: false });
	}
	
	handleKeepCancelClick() {
		// clear form, & close collapseß
		this.setState({ keepDetailsOpen: false, giftDetailsOpen: false  });
	}

	// Handle changes for 'input' elements
	handleInputChange(e) {
		const name = e.target.name;
		const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

		// TEMP: (TODO - remove when changing to multi add/edit/delete functionality)
		// set 'createdBy' field, when notes[0] is edited
		if (name === 'notes.0.text') {
			this.setState(produce(draftState => { draftState.item.notes[0].createdBy = this.props.currentUser._id }));
		}

		// regular input change code
		if (name.includes('.')) {		// Handle nested state values (TODO: update to hande N number of nested state values)
			const names = name.split('.');
			if (names.length === 2) {
				this.setState(produce(draftState => { draftState.item[names[0]][names[1]] = value }));
			}
			else if (names.length === 3) {
				this.setState(produce(draftState => { draftState.item[names[0]][names[1]][names[2]] = value }));
			}
		}
		else {							// Handle regular state values
			this.setState(produce(draftState => { draftState.item[name] = value }));
		}
	}
		
	// Handle data saving
	handleGiftItemFormSubmit(e) {
		// TODO: prevent submit on 'Enter' key press (https://github.com/react-hook-form/react-hook-form/discussions/2549#discussioncomment-143178)
		e.preventDefault();

		this.handleGiftItem();
	}
		
	handleKeepItemFormSubmit(e) {
		// TODO: prevent submit on 'Enter' key press (https://github.com/react-hook-form/react-hook-form/discussions/2549#discussioncomment-143178)
		e.preventDefault();

		this.handleKeepItem();
	}

	handleSkipItem() {
		const URI = skipItemURI + this.state.item._id;
		this.setState({ isSaving: true }, () => {
		axios.post(URI)
			.then(response => {
				this.setState({ item: response.data, isSaving: false, isLoading: true });
				this.getProgressStatus();
				this.getProgressList();
			})
			.catch(err => this.handleError(err, 'Error marking item as skipped.'));
		});
	}

	// TODO: consolidate (nearly identical) skip/keep/gift code - using 'action' property in postData (and single endpoint)
	handleKeepItem() {
		const URI = keepItemURI + this.state.item._id;
		const postData = {
			itemId: this.state.item._id,
			action: 'KEEP',
			notes: this.state.item.notes
		};
		this.setState({ isSaving: true }, () => {
		axios.post(URI, postData)
			.then(response => {
				this.setState({ item: response.data, keepDetailsOpen: false, isSaving: false, isLoading: true });
				this.getProgressStatus();
				this.getProgressList();
			})
			.catch(err => this.handleError(err, 'Error marking item as "KEEP".'));
		});
	}

	handleGiftItem() {
		const URI = giftItemURI + this.state.item._id;
		const postData = {
			itemId: this.state.item._id,
			action: 'GIFT',
			giftInfo: this.state.item.parrisCollectionInfo.giftInfo,
			notes: this.state.item.notes
		};
		this.setState({ isSaving: true }, () => {
		axios.post(URI, postData)
			.then(response => {
				this.setState({ item: response.data, giftDetailsOpen: false, isSaving: false, isLoading: true });
				this.getProgressStatus();
				this.getProgressList();
			})
			.catch(err => this.handleError(err, 'Error marking item as "GIFT".'));
		});
	}

	handleError(error, callingAction) {
		if (axios.isCancel(error)) {
			console.log(error);
		}
		else {
			const alertMessage = 'Oops! It looks like something went wrong. Please try again in a little while. Support info: [' + callingAction + ']';
			console.group('Error encountered:');
			console.log(callingAction);
			console.log(error);
			console.log('Current component state:');
			console.log(this.state);
			console.groupEnd();
			alert(alertMessage);
		}
	}

	imageKey() {
		// set image key to date of last edit that changed image, to force re-render on any image change (since image changes don't change imageRef in state)
		const indexOfLastImageEdit = this.state.item.editHistory.map(edit => (edit.editedProperties && edit.editedProperties.imageRef === '<new-image>')).lastIndexOf(true);
		const lastImageEditDate = this.state.item.editHistory[indexOfLastImageEdit] && this.state.item.editHistory[indexOfLastImageEdit].editedAt;
		return lastImageEditDate;
	}

	subTitles() {
		const subTitles = [this.state.item.subTitle].concat([this.state.item.bookInfo.subTitle].concat(this.state.item.bookInfo.collectionSubTitles));
		return subTitles.filter((a) => a).join(' • ');	// see same filter code above
	}

	colorBlocks() {
		const primaryColors = this.state.item.primaryColors;
		return (
			(primaryColors.length)
			?	primaryColors.map((currentItem, i) => {
					return <ColorBlock variant="display" key={currentItem.value} option={currentItem} />;
				})
			: ''
		);
	}

	dimensionsString() {
		const dimensions = this.state.item.dimensions;
		const values = [dimensions.length, dimensions.width, dimensions.height];
		return (
			(dimensions.length || dimensions.width || dimensions.height)
			?	values.join(' x ') + ' inches'
			:	null
		);
	}

	render() {
		return (
      <div className="fw-light mx-3">
        <LoadingOverlay show={this.state.isLoading} />
        <SavingOverlay show={this.state.isSaving} />
        <Offcanvas
					className="offcanvas-lg"
          placement="end"
          scroll={true}
          backdrop={false}
          show={this.state.progressListShow}
          onHide={this.handleListHide}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>List of Choices:</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
						{/* <hr /> */}
            <Table striped bordered hover size="lg">
              <thead className="text-muted">
                <tr>
                  <th>Done:</th>
                  <th>Piece:</th>
                  <th>Status:</th>
                </tr>
              </thead>
              <tbody>
								{
									(this.state.progressListItems)
									?
										this.state.progressListItems.map((currentItem, i) => {
											let decisionMade = (currentItem.parrisCollectionInfo.decision !== '');
											return (
												<tr className={(decisionMade) ? 'text-decoration-line-through' : ''}>
													<td className="text-center"><FontAwesomeIcon className={(decisionMade) ? 'text-success' : 'text-secondary'} icon={faCheckCircle} /></td>
													<td><ThumbImage item={currentItem} />{currentItem.title} - <em className="text-muted">{currentItem.creators[0]}</em></td>
													<td className="text-center"><ParrisDecision item={currentItem} /></td>
												</tr>
											);
										})
									: ''
								}
              </tbody>
            </Table>
          </Offcanvas.Body>
        </Offcanvas>
        <Row>
          <Col>
            <Card className="mb-3">
              <Card.Body>
                <div className="text-center text-muted">
                  <div>Art Collection:</div>
                  <h4>Item {this.state.progressListStatus.currentItemNumber} of {this.state.progressListStatus.totalCount}</h4>
                </div>
              </Card.Body>
							<Button
								className="position-absolute top-0 end-0 mt-2p5 me-2p5"
								variant="outline-info"
								size="xs"
								onClick={this.handleListShow}
							>
								<FontAwesomeIcon className="me-2" icon={faBars}/>
								List of Choices
							</Button>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <h2 className="fw-light mb-1">
              <span className={this.state.editingActive.title ? "d-none" : ""}>
                {this.state.item.title}
              </span>
              {/* <div className={(this.state.editingActive.title) ? '' : 'd-none'}>
								Title editing input here...
								</div> */}
              {/* <span className="d-inline-block align-middle p-4 fs-5" data-name="title" onClick={this.handleEditButtonClick}><FontAwesomeIcon icon={faPenToSquare}/></span> */}
              <span className="fs-4 fw-light ms-3">
                <em>{this.subTitles()}</em>
              </span>
            </h2>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <h5 className="fw-light text-muted">
              <em>{this.state.item.creators.join(" • ")}</em>
            </h5>
          </Col>
          <Col>
            <h5 className="fw-light float-end">
              <em>{this.state.item.medium}</em>
            </h5>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="ParrisReviewImage__Col text-center">
            <Row className="mb-4">
              <Col>
                <DetailImage
                  key={this.imageKey()}
                  item={this.state.item}
                  onLoad={this.handleImageLoaded}
									/>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* <Row>
          <Col className="mb-3">
            <h6 className="fw-light">
              <strong>Artwork Location: </strong>
              <em>Watergardens, Main House, Living Room, North Wall</em>
            </h6>
          </Col>
        </Row> */}
        <Row>
          <Col>
            <Collapse in={this.state.keepDetailsOpen}>
              <Form
                id="keep-details-form"
                className="mt-4 mb-4"
                onSubmit={this.handleKeepItemFormSubmit}
								>
                <h3>Keep in Collection:</h3>
                <Row className="mb-5">
                  <Col>
                    <Form.Group controlId="formKeepNotes">
                      <Form.Label>Notes:</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="(Optional) Please add any additional info you'd like to, about this item in the collection."
                        name="notes.0.text"
                        value={this.state.item.notes[0].text}
                        onChange={this.handleInputChange}
                        tabIndex="1"
												/>
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  className="float-end mb-4"
                  variant="warning"
                  size="xl"
                  type="submit"
									>
                  Save
                </Button>
                <Button
                  className="float-end mb-4 me-3"
                  variant="secondary"
                  size="xl"
                  onClick={this.handleKeepCancelClick}
									>
                  Cancel
                </Button>
              </Form>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Col>
            <Collapse in={this.state.giftDetailsOpen}>
              <Form
                id="gift-details-form"
                className="mt-4 mb-4"
                onSubmit={this.handleGiftItemFormSubmit}
								>
                <h3>Gift Details:</h3>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="formGiftFirstName">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="First name"
                        name="parrisCollectionInfo.giftInfo.firstName"
                        value={
													this.state.item.parrisCollectionInfo.giftInfo
													.firstName
                        }
                        onChange={this.handleInputChange}
                        tabIndex="1"
                        required
												/>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formGiftLastName">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Last name"
                        name="parrisCollectionInfo.giftInfo.lastName"
                        value={
													this.state.item.parrisCollectionInfo.giftInfo.lastName
                        }
                        onChange={this.handleInputChange}
                        tabIndex="2"
                        required
												/>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col>
                    <Form.Group controlId="formGiftAdditionalDetails">
                      <Form.Label>Additional Details</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Please add address, contact information, or any other gift notes."
                        name="parrisCollectionInfo.giftInfo.additionalDetails"
                        value={
													this.state.item.parrisCollectionInfo.giftInfo
													.additionalDetails
                        }
                        onChange={this.handleInputChange}
                        tabIndex="3"
												/>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col>
                    <Form.Group controlId="formGiftNotes">
                      <Form.Label>Notes:</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="(Optional) Please add any additional info you'd like to, about this item in the collection."
                        name="notes.0.text"
                        value={this.state.item.notes[0].text}
                        onChange={this.handleInputChange}
                        tabIndex="4"
												/>
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  className="float-end mb-4"
                  variant="warning"
                  size="xl"
                  type="submit"
									>
                  Save
                </Button>
                <Button
                  className="float-end mb-4 me-3"
                  variant="secondary"
                  size="xl"
                  onClick={this.handleGiftCancelClick}
									>
                  Cancel
                </Button>
              </Form>
            </Collapse>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="text-center">
            <Button
              className="mb-4"
              variant="surprise"
              size="xl"
              onClick={this.handleKeepItemClick}
              aria-expanded={this.state.keepDetailsOpen}
							>
              Keep in Collection
            </Button>
          </Col>
          <Col className="text-center d-flex align-items-center" xs="auto">
            <Button
              className="mb-4"
              variant="light"
              size="xl"
              onClick={this.handleSkipItem}
							>
              Skip
            </Button>
          </Col>
          <Col className="text-center">
            <Button
              className="mb-4"
              variant="success"
              size="xl"
              onClick={this.handleGiftItemClick}
              aria-expanded={this.state.giftDetailsOpen}
							>
              Gift to Someone
            </Button>
          </Col>
        </Row>
      </div>
    );
	}
}

export default withRouter(ParrisView);